module.exports = __webpack_public_path__ + "assets/img/1.4383b64d.gif";